export default __webpack_public_path__ + "static/media/makepost.dc0837f9.jpg";